<template>
    <div class="animated fadeIn efficiency">
        <filters :scope="filtersScope">
        </filters>
        <OperatorsTab></OperatorsTab>
        <modal small title="" v-model="bonusModal" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
                <h4 class="modal-title">{{ $t('statistic.bonus_system') }}</h4>
            </div>
            <div class="form-group">
                <div class="input-group">
                    <span class="input-group-addon">{{ $t('statistic.old_bonus') }}</span>
                    <input type="text" v-model="oldBonusRate" class="form-control" :disabled="isLoading">
                </div>
            </div>
            <div class="form-group">
                <div class="input-group">
                    <span class="input-group-addon">{{ $t('statistic.new_bonus') }}</span>
                    <input type="text" v-model="newBonusRate" class="form-control" :disabled="isLoading">
                </div>
            </div>
            <div class="form-group" v-if="error">
                <div class="input-group">
                    <div class="alert alert-danger">
                        {{ error }}
                    </div>
                </div>
            </div>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-outline-info" @click="bonusModal = false"> {{ $t('verbs.close') }}
                </button>
                <button type="submit" class="btn btn-sm btn-primary" @click="applyBonus()" :disabled="isLoading">
                    {{ $t('verbs.apply') }}
                </button>
            </div>
        </modal>

        <modal large title="" v-model="exportHistiryModal" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
            </div>
            <StatisticTable :headColumns="exportHeadColumns"
                            :footColumns="{}"
                            :rows="exportRows"
                            :title="`${$t('statistic.exporting_history')}`">
            </StatisticTable>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-outline-info" @click="exportHistiryModal = false">
                    {{ $t('verbs.close') }}
                </button>
            </div>
        </modal>

        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :columns="columns"
                        ref="statisticTable"
                        :isExelAll="true"
                        @isPopup="isPopup"
                        :isFlypostModal="true"
                        @exportingAll="exportingAll"
                        :title="`${$t('pages.efficiency')}`"
                        class="exelAll"
        >
            <template slot="table-actions">
                <button class="btn-close btn-exp" @click="exportBonus(0)">{{ $t('statistic.old_bonus') }}</button>
                <button class="btn-close" @click="toggleExportHistoryModal()"><i class="fa fa-book"></i></button>
                <button class="btn-close" @click="toggleBonusModal()"><i class="fa fa-dollar"></i></button>
            </template>
        </StatisticTable>
    </div>
</template>

<script>
    import Filters from '../../../components/Filters.vue'
    import API from '../../../api/API'
    import Storage from '../../../api/Storage'
    import { map, orderBy } from 'lodash'
    import Helper from '../../../api/Helper'
    import TypeColor from '../../../assets/TypeColor'
    import StatisticTable from '../../../components/StatisticTable.vue'
    import { dropdown, modal } from 'vue-strap'
    import FileSaver from 'file-saver'
    import OperatorsTab from './OperatorsTab'

export default {
      name: 'Efficiency',
      components: {
        Filters,
        StatisticTable,
        modal,
        dropdown,
        OperatorsTab
      },
      data () {
        return {
          filtersScope: {
            dateFilter: true,
            offerFilter: true,
            operatorFilter: true
          },
          isLoading: false,
          Storage: Storage,
          TypeColor: TypeColor,
          Helper: Helper,
          country: null,
          columns: null,
          headColumns: [
                    { label: 'ID', field: 'id' },
                    {label: this.$root.$t('statistic.operator'), field: 'operator'},
                    {label: this.$root.$t('statistic.processed_leads'), field: 'processed'},
                    {label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2},
                    {label: this.$root.$t('statistic.additional_sale'), field: 'additionalSale'},
                    {label: this.$root.$t('statistic.averageBill'), field: 'averageBill'},
                    {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback'},
                    {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2, splitter: true},
                    {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
                    {label: this.$root.$t('statistic.acceptedSum'), field: 'acceptedSum'},
                    {label: this.$root.$t('statistic.buyoutSum'), field: 'paidSum'},
                    {label: this.$root.$t('statistic.old_bonus'), field: 'oldBonus'},
                    {label: this.$root.$t('statistic.revenue_lead'), field: 'revenue_lead'},
                    {label: this.$root.$t('statistic.deviation_mean'), field: 'deviation_mean'}
                    // {label: this.$root.$t('statistic.new_bonus'), field: 'newBonus'}
          ],
          rows: [],
          footColumns: {},
          oldBonusRate: 0.16,
          newBonusRate: 0.0,
          systemOldBonusSum: 0,
                // systemNewBonusSum: 0,
          oldBonusSum: 0,
                // newBonusSum: 0,
          error: null,
          bonusModal: false,
          exportHistiryModal: false,
          exportHeadColumns: [
                    {label: this.$root.$t('verbs.manager'), field: 'manager'},
                    {label: this.$root.$t('statistic.offer'), field: 'offer'},
                    {label: this.$root.$t('statistic.date'), field: 'date'},
                    {label: this.$root.$t('filters.period'), field: 'period'},
                    {label: this.$root.$t('statistic.system_bonus'), field: 'oldBonus'}
                    // {label: this.$root.$t('statistic.paid_bonus'), field: 'newBonus'}
          ],
          exportRows: [],
          operators: []
        }
      },
      mounted () {
        this.calculateRows()
        this.$root.$on('filters_load_new_data', () => {
          this.calculateRows()
        })
      },
      methods: {
        isPopup (cell) {
          let el = document.createElement('textarea')
          el.value = cell.value.trim()
          el.setAttribute('readonly', '')
          el.style.position = 'absolute'
          el.style.left = '-9999px'
          document.body.appendChild(el)
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
          alert('Скопирован оператор ' + el.value)
        },
        toggleExportHistoryModal () {
          if (!this.exportHistiryModal) {
            this.exportRows = []
            API.getOperatorStatisticExportHistory().then((response) => {
              const orderedResponse = orderBy(response.body, ['date'], ['ASC'])
              orderedResponse.map((d) => {
                this.exportRows.push({
                  manager: {value: d.manager, bg: true},
                  offer: {value: Helper.getExportedOffers(d.offer_id), bg: true},
                  date: {value: d.date, bg: true},
                  period: {value: d.period, bg: true},
                  systemBonus: {value: `$ ${d.system_bonus}`, bgc: d.bonus_type === 0 ? TypeColor.oldBonusHistory : TypeColor.newBonusHistory},
                  paidBonus: {value: `$ ${d.paid_bonus}`, bgc: d.bonus_type === 0 ? TypeColor.oldBonusHistory : TypeColor.newBonusHistory}
                })
              })
              this.exportHistiryModal = true
            }).catch((response) => {
              this.$notify({
                type: 'danger',
                title: this.$root.$t('verbs.error'),
                text: response.body.message ? response.body.message : response.body,
                animationType: 'velocity'
              })
            })
          } else {
            this.exportHistiryModal = false
          }
        },
        exportBonus (type) {
          API.saveOperatorStatisticExportHistory(type === 0 ? this.systemOldBonusSum : this.systemNewBonusSum, type === 0 ? this.oldBonusSum : this.newBonusSum, type).then(() => {
            this.columns = {
              operator: true,
              processed: true,
              accepted: true,
              averageBill: true,
              paidSum: true,
              additionalSale: true,
              oldBonus: type === 0,
              newBonus: type === 1
            }
            this.headColumns[6].label = this.$root.$t('statistic.paid')
            this.$nextTick(function () {
              this.$refs.statisticTable.exporting(null)
              this.headColumns[6].label = this.$root.$t('statistic.buyoutSum')
              this.columns = null
            })
          }).catch(() => {
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: this.$root.$t('statistic.export_error'),
              animationType: 'velocity'
            })
          })
        },
        toggleBonusModal () {
          this.bonusModal = !this.bonusModal
        },
        applyBonus () {
          this.error = null
          if ((!Helper.isFloat(parseFloat(this.oldBonusRate)) && !Helper.isInt(parseFloat(this.oldBonusRate))) || (!Helper.isInt(parseFloat(this.newBonusRate)) && !Helper.isInt(parseFloat(this.newBonusRate)))) {
            this.error = this.$root.$t('verbs.invalid_parameters')
          } else {
            this.toggleBonusModal()
            this.calculateRows(true)
          }
        },
        async calculateRows (isApplyBonus) {
          this.$root.$emit('data_loading')
          this.rows = []
          this.operators = []
          await API.getOperators(Helper.getCountryList()).then(operators => {
            this.operators = operators.body
          })
          await API.getOperatorStatistic().then(response => {
            let countItems = response.body.length
            let sumProcessedLeads = 0
            let sumAccepted = 0
            let sumAcceptedRevenua = 0
            let countAcceptedRevenua = 0
            let countAccepted = 0
            let sumPaid = 0
            let countPaid = 0
            let sumPaidRevenua = 0
            let countPaidRevenua = 0
            let sumReturn = 0
            let countReturn = 0
            let sumAverageBill = 0.0
            let sumAverageBuyback = 0.0
            let sumAverageSum = 0.0
            let sumBuyoutSum = 0.0
            let sumAdditionslSale = 0
            let countAdditionalSale = 0
            let sumOldBonus = 0
            let countOldBonus = 0
            let resultAverageLead = 0.0
            let resultRevenuaLeadAverage = 0.0
            let count = 0
            if (!isApplyBonus) {
              this.newBonusRate = 0.0
              const sortedData = orderBy(response.data, [function (item) {
                return item.average_bill * item.buyout
              }], ['desc'])
              let topIndex = 0
              for (; topIndex < 10; topIndex++) {
                if (sortedData[topIndex]) {
                  if (sortedData[topIndex].additional_sale < 0) {
                    sortedData[topIndex].additional_sale = 0
                  }
                  if (parseFloat(Helper.averageBill(sortedData[topIndex].average_bill * sortedData[topIndex].buyout, false, true)) < 1) {
                    break
                  }
                  this.newBonusRate += parseFloat(Helper.averageBill(sortedData[topIndex].average_bill * sortedData[topIndex].buyout, false, true)) / parseFloat(sortedData[topIndex].additional_sale * this.oldBonusRate)
                } else {
                  break
                }
              }
              this.newBonusRate = parseFloat(parseFloat(this.newBonusRate) / parseFloat(topIndex)).toFixed(0)
              if (isNaN(this.newBonusRate)) {
                this.newBonusRate = 0
              }
              this.systemNewBonusRate = this.newBonusRate
            }
              // парсим
            map(response.data, (d) => {
              let oldBonus = parseFloat(parseFloat(d.additional_sale) * this.oldBonusRate).toFixed(0)
              if (d) {
                count++
              }
              if (isNaN(oldBonus)) {
                oldBonus = 0
              }
              if (d.approved > 0) {
                sumAcceptedRevenua += parseInt(d.approved)
                countAcceptedRevenua++
              }
              if (d.buyout > 0) {
                sumPaidRevenua += parseInt(d.buyout)
                countPaidRevenua++
              }
              if (d.approved) {
                countAccepted++
                sumAverageBill += parseFloat(d.average_bill_usd) * parseInt(d.approved)
                sumAverageBuyback += parseFloat(d.average_buyout_usd) * parseInt(d.buyout)
                sumAccepted += parseInt(d.approved)
              }
              if (d.buyout > 0) {
                sumPaid += parseInt(d.buyout)
                countPaid++
              }

              let percentPaid = Helper.percents(d.approved, d.buyout).replace('%', '').replace(',', '.')
              let revenuaLead = d.average_buyout_usd * (parseFloat(percentPaid) / 100)
              let averageBuyoutGlobal = Helper.averageBill(d.average_buyout_global_usd).replace('$', '').replace(',', '.')
              let averageSum = (Helper.percents(sumAcceptedRevenua, sumPaidRevenua).replace('%', '').replace(',', '.'))
              resultAverageLead = averageBuyoutGlobal / averageSum * 100
              this.$nextTick(function () {
                let rezultDeviation = 0.0
                rezultDeviation = resultRevenuaLeadAverage > 0 ? -(1 - revenuaLead / resultRevenuaLeadAverage) * 100 : 0
                this.rows.push({
                  id: {
                    value: d.operator_id
                  },
                  operator: {value: `${Helper.getOperatorLogin(this.operators, d.operator_id)} ${Storage.developMode ? `(${d.operator_id})` : ''}`, popup: true},
                  processed: {
                    value: d.total,
                    bg: true,
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  accepted: {
                    value: d.approved,
                    isCollspaned: true,
                    bgg: Helper.renderGistPart(d.total, d.approved),
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  acceptedPercents: {
                    value: Helper.percents(parseInt(d.total), parseInt(d.approved)),
                    isCollspaned: true,
                    bgg: Helper.renderGistPart(d.total, d.approved, true),
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  additionalSale: {
                    value: d.additional_sale,
                    bg: true
                  },
                  averageBill: {
                    value: '$ ' + d.average_bill_usd.toFixed(2)
                      // bgg: Helper.renderSingleGist(100, Helper.averageBill(d.average_bill_usd, false, true))
                  },
                  averageBuyback: {
                    value: '$ ' + d.average_buyout_usd.toFixed(2)
                      // bgg: Helper.renderSingleGist(100, Helper.averageBill(d.average_buyout_global_usd, false, true))
                  },
                  paid: {
                    value: d.buyout,
                    bgg: Helper.renderGistPart(d.approved, d.buyout),
                    isCollspaned: true
                  },
                  paidPercents: {
                    value: Helper.percents(d.approved, d.buyout),
                    bgg: Helper.renderGistPart(d.approved, d.buyout, true),
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  return: {
                    value: d.return,
                    bgg: Helper.renderGistPart(d.approved, d.return),
                    isCollspaned: true
                  },
                  returnPercents: {
                    value: Helper.percents(d.approved, d.return),
                    bgg: Helper.renderGistPart(d.approved, d.return, true),
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  acceptedSum: {
                    value: '$ ' + (d.average_bill_usd * d.approved).toFixed(2),
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  paidSum: {
                    value: '$ ' + (d.average_buyout_usd * d.buyout).toFixed(2),
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  oldBonus: {
                    value: `$ ${oldBonus}`,
                    ocb: (value) => {
                      return Helper.getRawNumber(value)
                    }
                  },
                  revenue_lead: {
                    value: '$ ' + revenuaLead.toFixed(2)
                  },
                  deviation_mean: {
                    value: rezultDeviation.toFixed(2) + '%',
                    plusBg: rezultDeviation >= 0
                  }
                })
              })
              if (d.total > 0) {
                sumProcessedLeads += parseInt(d.total)
              }
              if (oldBonus > 0) {
                sumOldBonus += parseInt(oldBonus, 10)
                countOldBonus++
              }
              sumReturn += parseInt(d.return)
              if (d.return > 0) {
                countReturn++
              }
              if (d.additional_sale > 0) {
                sumAdditionslSale += parseInt(d.additional_sale)
                countAdditionalSale++
              }
              sumAverageSum += (d.average_bill_usd * d.approved)
              sumBuyoutSum += (d.average_buyout_usd * d.buyout)
            })

            let sumAverageBuybackRevenua = Helper.averageBillDayCount(sumAverageBuyback, sumPaid).replace('$', '').replace(',', '.')
            let paidPercentsRevenua = Helper.percents(sumAccepted, sumPaid).replace('%', '').replace(',', '.')
            resultRevenuaLeadAverage = ((sumAverageBuybackRevenua * paidPercentsRevenua) / 100).toFixed(2)
            this.footColumns = {
              id: {
                value: ' '
              },
              label: {
                value: this.$root.$t('statistic.in_total')
              },
              processed: {
                value: `${sumProcessedLeads}`
              },
              accepted: {
                value: `${sumAccepted}`
              },
              acceptedPercents: {
                value: Helper.percents(sumProcessedLeads, sumAccepted)
              },
              additionalSale: {
                value: `${sumAdditionslSale}`
              },
              averageBill: {
                value: Helper.averageBillDayCount(sumAverageBill, sumAccepted)
              },
              averageBuyback: {
                value: Helper.averageBillDayCount(sumAverageBuyback, sumPaid)
              },
              paid: {
                value: `${sumPaid}`
              },
              paidPercents: {
                value: Helper.percents(sumAccepted, sumPaid)
              },
              return: {
                value: `${sumReturn}`
              },
              returnPercents: {
                value: Helper.percents(sumAccepted, sumReturn)
              },
              acceptedSum: {
                value: '$ ' + (sumAverageSum / countItems).toFixed(2)
              },
              paidSum: {
                value: '$ ' + (sumBuyoutSum / countItems).toFixed(2)
              },
              oldBonus: {
                value: `$ ${sumOldBonus}`
              },
              revenue_lead: {
                value: `$ ${resultRevenuaLeadAverage}`
              }
            }
            if (!isApplyBonus) {
              this.systemOldBonusSum = this.oldBonusSum = sumOldBonus
                // this.systemNewBonusSum = this.newBonusSum = sumNewBonus
            } else {
              this.oldBonusSum = sumOldBonus
                // this.newBonusSum = sumNewBonus
            }
            this.$root.$emit('data_loaded')
          }).catch(response => {
            this.$root.$emit('data_loaded')
            this.$notify({
              type: 'danger',
              title: this.$root.$t('verbs.error'),
              text: !response.body.message ? response.body : response.body.message,
              animationType: 'velocity'
            })
          })
        },
        exportingAll () {
          let doc = []
          this.rows.forEach(item => {
            doc.push(`<?xml version="1.0"?>
            <?mso-application progid="Excel.Sheet"?>
            <Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
             xmlns:o="urn:schemas-microsoft-com:office:office"
             xmlns:x="urn:schemas-microsoft-com:office:excel"
             xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
             xmlns:html="http://www.w3.org/TR/REC-html40">
             <DocumentProperties xmlns="urn:schemas-microsoft-com:office:office">
             </DocumentProperties>
             <ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel">
             </ExcelWorkbook>
             <Styles>
              <Style ss:ID="Default" ss:Name="Normal">
               <Alignment ss:Vertical="Bottom"/>
               <Borders/>
               <Font ss:FontName="Calibri" x:CharSet="204" x:Family="Swiss" ss:Size="11" ss:Color="#000000"/>
               <Interior/>
               <NumberFormat/>
               <Protection/>
              </Style>
              <Style ss:ID="s62">
               <NumberFormat ss:Format="#,##0.00&quot;р.&quot;"/>
              </Style>
             </Styles>
             <Worksheet ss:Name="${item.operator.value}">
              <Table ss:ExpandedColumnCount="2" ss:ExpandedRowCount="3" x:FullColumns="1" x:FullRows="1" ss:DefaultRowHeight="15">
               <Row ss:AutoFitHeight="0">
                <Cell><Data ss:Type="String">Оператор</Data></Cell>
                <Cell><Data ss:Type="String">Обработано лидов</Data></Cell>
                <Cell><Data ss:Type="String">Одобрено</Data></Cell>
               </Row>
              </Table>
              <WorksheetOptions xmlns="urn:schemas-microsoft-com:office:excel">
               <PageSetup>
                <Header x:Margin="0.3"/>
                <Footer x:Margin="0.3"/>
                <PageMargins x:Bottom="0.75" x:Left="0.7" x:Right="0.7" x:Top="0.75"/>
               </PageSetup>
               <Unsynced/>
               <Print>
                <ValidPrinterInfo/>
                <PaperSizeIndex>9</PaperSizeIndex>
                <HorizontalResolution>600</HorizontalResolution>
                <VerticalResolution>600</VerticalResolution>
               </Print>
               <Selected/>
               <ProtectObjects>False</ProtectObjects>
               <ProtectScenarios>False</ProtectScenarios>
              </WorksheetOptions>
             </Worksheet>
            </Workbook>`)
          })
          FileSaver.saveAs(new Blob([doc], {
            encoding: 'UTF-8',
            type: 'application/octet-stream'
          }), `analytics-offers.xls`)
        }
      }
    }
</script>



// WEBPACK FOOTER //
// Efficiency.vue?4682c004